<div *ngIf="pelicula$ | async as filme">
<!-- {{ (pelicula$ | async).titulo }} -->
  <img [src]="'assets/posteres/'+ filme.id +'.jpg'" alt="" class="miniimg" [class]="entrada ? 'ingreso' : 'egreso' ">
  <h5 [class]="entrada ? 'ingreso' : 'egreso' "> {{ filme.titulo }} </h5>
  <span> {{ filme.pais  }} </span>
</div>
